import { Component, Input } from '@angular/core';

@Component({
  selector: 'sp-logo',
  standalone: false,
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']

})
export class LogoComponent implements LogoInterface {
  @Input() type: string = 'primary';
  @Input() theme: string = 'light';

  private logoType = {
    light: {
      primary: 'primary',
      'primary-slogan': 'primary-slogan',
      symbol: 'symbol',
      icon: 'app icon'
    },
    dark: {
      primary: 'primary/dark-theme',
      'primary-slogan': 'primary-slogan/dark-theme',
      symbol: 'Symbol/no box',
      icon: 'app icon/dark theme'
    },
    ghost: {
      primary: 'primary/ghost-theme',
      'primary-slogan': 'primary-slogan/ghost-theme',
      symbol: 'Symbol/ghost',
      icon: 'app icon/ghost'
    }
  };

  constructor() {}

  logoPath(): string {
    const { logoType, theme, type } = this;
    const logoTypeString = logoType[theme][type];
    return `/public/logo/${logoTypeString}.svg`;
  }
}

export interface LogoInterface {
  type: string;
  theme: string;
}